import { useCallback, useMemo, useState } from 'react';
import { WebArService } from '@/ui-kit/domain/WebArService';
import { embeddingService } from '@/ui-kit/services/embedding/EmbeddingService';
import { API } from '@canvas-logic/clp-viewer3d';
import { useBootstrapper } from '@/ui-kit/contexts/BootstrapperContext';

type State = 'idle' | 'ready' | 'loading';

type Args = {
  api: API;
};

type Value = {
  state: State;
  link: string;
  generate: () => Promise<void>;
  reset: () => void;
};

/**
 * @todo get API from `useBootstrapper`
 */
export const useGetArLink = ({ api }: Args) => {
  const [state, setState] = useState<State>('idle');
  const [link, setLink] = useState('');
  const { bootstrapper } = useBootstrapper();

  const webArService = useMemo(() => {
    return new WebArService(api);
  }, [api]);

  const generate = useCallback(async () => {
    if (state === 'loading') {
      return;
    }

    if (state !== 'ready') {
      setState('loading');
      try {
        const link = await webArService.generateArLink(bootstrapper!.projectId.toString());
        const hostDeviceType = await embeddingService.getHostDeviceType();
        if (hostDeviceType === 'desktop') {
          setState('ready');
          setLink(link);
        } else {
          window.location.replace(link);
        }
      } catch (e: unknown) {
        console.error(e);
        setState('idle');
      }
    }
  }, [state, webArService]);

  const reset = useCallback(() => {
    setState('idle');
  }, []);

  return useMemo<Value>(
    () => ({
      state,
      link,
      generate,
      reset,
    }),
    [state, link, generate, reset],
  );
};
